import * as React from 'react'
import { useState, useEffect } from 'react'
import uuid from 'uuid/v4'
import { useQuery } from 'react-query'
import { getTasks } from '../../../api/tasks'
import DuplicateFormFieldsRow from './DuplicateFormFieldsRow'
import DuplicateFormExistingJobPlannings from './DuplicateFormExistingJobPlannings'
import ErrorMessage from './ErrorMessage'

type DuplicateFormFieldsProps = {
  jobPlanning: {
    jobnumber_id: string
    jobnumber: {
      id: string
      name: string
    }
    quantity: string
    comment: string
    actually_completed: string
    description: string
    finished_date: string
    placement: string
  }
}

export default function DuplicateFormFields({ jobPlanning }: DuplicateFormFieldsProps) {
  const { jobnumber } = jobPlanning
  const [rows, setRows] = useState([])

  const { isLoading, data: tasks, error } = useQuery(['tasks', jobnumber.id], () => getTasks(jobnumber.id))

  const insertRow = () => setRows([...rows, { ...jobPlanning, id: uuid() }])
  const removeRow = id => setRows(rows.filter(row => row.id !== id))

  useEffect(() => {
    insertRow()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (isLoading) {
    return (
      <div className="text-center">
        <i className="fa fa-spinner fa-spin fa-2x" />
      </div>
    )
  }
  if (error) {
    return <ErrorMessage isError={true} error={error} className="job-plannings-table-error" />
  }

  return (
    <table className="table job-planning-clone-table">
      <thead>
        <tr>
          <th className="align-middle">Opgnr.</th>
          <th className="align-middle">Slutdato</th>
          <th className="align-middle">Nr</th>
          <th className="align-middle">Timer</th>
          <th className="align-middle">Bemærkning</th>
          <th className="align-middle">Placering</th>
          <th className="align-middle">
            <button className="btn btn-primary btn-sm job-planning-clone-table-add" type="button" onClick={insertRow}>
              +
            </button>
          </th>
        </tr>
      </thead>
      <tbody>
        <DuplicateFormExistingJobPlannings jobPlanning={jobPlanning} />
        {rows.map((row, idx) => {
          return (
            <DuplicateFormFieldsRow
              key={row.id}
              jobPlanning={row}
              fieldName={field => `job_plannings[${idx}][${field}]`}
              removeRow={() => removeRow(row.id)}
              tasks={tasks}
              showRemoveFieldsButton={rows.length > 1}
            />
          )
        })}
      </tbody>
    </table>
  )
}
